import React, { useContext } from "react";
import classNames from "classnames";
import TabContext from "../TabContext";
import TabContainer from "./Tab.styles";
import { defaultProps } from "./Props";
const Tab = ({ children, className, tabGroup, click }) => {
  const { activeTab, setActiveTab } = useContext(TabContext);
  const isActive = tabGroup === activeTab;
  const classes = classNames("tab", className, {
    activeTab: isActive,
    inactive: !isActive
  });
  const clickHandler = () => {
    if (click)
      click();
    setActiveTab(tabGroup);
  };
  return /* @__PURE__ */ React.createElement(TabContainer, {
    role: "tab",
    className: classes,
    onClick: clickHandler,
    "aria-selected": isActive,
    "aria-controls": tabGroup,
    onKeyPress: (e) => e.key === "Enter" && clickHandler(),
    tabIndex: 0
  }, children);
};
Tab.defaultProps = defaultProps;
export default Tab;
